import { GlBadge } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import MultipleChoiceSelector from '../../../../../../../app/assets/javascripts/vue_shared/components/multiple_choice_selector.vue?vue3';
import MultipleChoiceSelectorItem from '../../../../../../../app/assets/javascripts/vue_shared/components/multiple_choice_selector_item.vue?vue3';
export default {
    name: 'DuoMultiSelectOptions',
    components: {
        GlBadge,
        MultipleChoiceSelector,
        MultipleChoiceSelectorItem
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        checkedIds: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'input'
    ],
    expose: [
        'focus'
    ],
    computed: {
        optionRows () {
            const checked = new Set(this.checkedIds);
            return this.options.map((option)=>({
                    ...option,
                    isChecked: checked.has(option.id)
                }));
        }
    },
    methods: {
        focus () {
            this.$refs.firstOption?.[0]?.focus();
        }
    }
};
